export default __webpack_public_path__ + "fonts/Unna-Regular.woff2";